import { render } from "./GameParity.vue?vue&type=template&id=257c369c"
import script from "./GameParity.vue?vue&type=script&lang=js"
export * from "./GameParity.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__